__turbopack_context__.v({
  "active": "aIiXJq_active",
  "add-to-cart-button": "aIiXJq_add-to-cart-button",
  "arrows": "aIiXJq_arrows",
  "bulkAddBar": "aIiXJq_bulkAddBar",
  "bulkAddButton": "aIiXJq_bulkAddButton",
  "buttonsContainer": "aIiXJq_buttonsContainer",
  "cart-btn-close": "aIiXJq_cart-btn-close",
  "checkboxRow": "aIiXJq_checkboxRow",
  "groupedDescription": "aIiXJq_groupedDescription",
  "groupedHeaderRow": "aIiXJq_groupedHeaderRow",
  "groupedProductPrice": "aIiXJq_groupedProductPrice",
  "groupedProductWrapper": "aIiXJq_groupedProductWrapper",
  "groupedTotalPrice": "aIiXJq_groupedTotalPrice",
  "groupedWishlist": "aIiXJq_groupedWishlist",
  "infoContainer": "aIiXJq_infoContainer",
  "leftArrowSlickSuggSet": "aIiXJq_leftArrowSlickSuggSet",
  "pdp-qty": "aIiXJq_pdp-qty",
  "pdpPrice": "aIiXJq_pdpPrice",
  "pdpProductPrice": "aIiXJq_pdpProductPrice",
  "pricePerUnitCont": "aIiXJq_pricePerUnitCont",
  "product-name": "aIiXJq_product-name",
  "productButton": "aIiXJq_productButton",
  "productCard": "aIiXJq_productCard",
  "productCardSlider": "aIiXJq_productCardSlider",
  "productDetail": "aIiXJq_productDetail",
  "productDetailWrapper": "aIiXJq_productDetailWrapper",
  "productImage": "aIiXJq_productImage",
  "productList": "aIiXJq_productList",
  "productName": "aIiXJq_productName",
  "productPrice": "aIiXJq_productPrice",
  "productTopInfo": "aIiXJq_productTopInfo",
  "qtySelector": "aIiXJq_qtySelector",
  "qtyTitle": "aIiXJq_qtyTitle",
  "quantity": "aIiXJq_quantity",
  "rightArrowSlickSuggSet": "aIiXJq_rightArrowSlickSuggSet",
  "scrollableContent": "aIiXJq_scrollableContent",
  "select-variant": "aIiXJq_select-variant",
  "separator": "aIiXJq_separator",
  "setContainer": "aIiXJq_setContainer",
  "shortDescription": "aIiXJq_shortDescription",
  "sidebarImageSlider": "aIiXJq_sidebarImageSlider",
  "sidebarPanel": "aIiXJq_sidebarPanel",
  "sku": "aIiXJq_sku",
  "title": "aIiXJq_title",
});
